// Minimal inline SVG icons, no icon-font dependency. All decorative (always
// paired with visible text or an aria-label), hence aria-hidden throughout.
const SVG_NS = "http://www.w3.org/2000/svg";

function svg(paths: { d?: string; x?: string; y?: string; width?: string; height?: string; rx?: string; cx?: string; cy?: string; r?: string; tag?: string }[]): SVGElement {
  const root = document.createElementNS(SVG_NS, "svg");
  root.setAttribute("viewBox", "0 0 24 24");
  root.setAttribute("fill", "none");
  root.setAttribute("stroke", "currentColor");
  root.setAttribute("stroke-width", "1.6");
  root.setAttribute("stroke-linecap", "round");
  root.setAttribute("stroke-linejoin", "round");
  root.setAttribute("aria-hidden", "true");
  root.setAttribute("focusable", "false");
  for (const p of paths) {
    const el = document.createElementNS(SVG_NS, p.tag ?? "path");
    for (const [k, v] of Object.entries(p)) {
      if (k === "tag" || v === undefined) continue;
      el.setAttribute(k, v);
    }
    root.append(el);
  }
  return root;
}

export function iconFile(): SVGElement {
  return svg([{ d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }, { d: "M14 2v6h6" }]);
}

export function iconLockCylinder(): SVGElement {
  return svg([{ tag: "circle", cx: "12", cy: "12", r: "2.2" }]);
}

export function iconTrash(): SVGElement {
  return svg([
    { d: "M3 6h18" },
    { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" },
    { d: "M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" },
  ]);
}

export function iconPlus(): SVGElement {
  return svg([{ d: "M12 5v14M5 12h14" }]);
}

export function iconShield(): SVGElement {
  return svg([
    { d: "M12 2 4 5v6c0 5 3.4 8.6 8 9 4.6-.4 8-4 8-9V5l-8-3Z" },
    { d: "m9 12 2 2 4-4" },
  ]);
}

export function iconLock(): SVGElement {
  return svg([
    { tag: "rect", x: "3", y: "11", width: "18", height: "10", rx: "2" },
    { d: "M7 11V7a5 5 0 0 1 10 0v4" },
  ]);
}

export function iconCopy(): SVGElement {
  return svg([
    { tag: "rect", x: "9", y: "9", width: "12", height: "12", rx: "2" },
    { d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" },
  ]);
}

export function iconCheck(): SVGElement {
  return svg([{ d: "M20 6 9 17l-5-5" }]);
}

export function iconAlert(): SVGElement {
  return svg([
    { d: "M12 9v4" },
    { d: "M12 17h.01" },
    { d: "M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" },
  ]);
}

export function iconClose(): SVGElement {
  return svg([{ d: "M18 6 6 18" }, { d: "M6 6l12 12" }]);
}

export function iconPin(): SVGElement {
  return svg([
    { d: "M12 17v5" },
    { d: "M9 3h6l-1 6 3 3v2H7v-2l3-3Z" },
  ]);
}
